module.exports = __webpack_public_path__ + "img/3.9b93aa6.jpg";